<template>
    <v-card>
        <v-card-title
            class="justify-center"
            style="font-size: 1.5em; font-weight: 700;"
        >
            Detalhes do Voucher
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-card flat v-if="compra && compra.combustivel">
                <v-card-text>
                    <v-layout justify-center column>
                        <v-flex xs5 style="justify-content: center; display:flex;">
                        <svg-filler
                            :path="
                            compra.combustivel.icone
                                ? require(`@/assets/combs/${compra.combustivel.icone}.svg`)
                                : require(`@/assets/combs/gas.svg`)
                            "
                            width="70px"
                            height="70px"
                            :fill="compra.combustivel.color"
                        />
                        </v-flex>
                        <v-flex xs5>
                            <h2 :style="{color: compra.combustivel.color, 'text-align': 'center'}">{{ compra.combustivel.nome }}</h2>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-layout wrap justify-space-around fill-height>
                <v-flex xs4>
                    <h5>Valor:</h5>
                    <h2
                        class="text-xs-center mb-4"
                        v-if="compra.combustivel || (compra.pedido && compra.pedido.itens[0] && compra.pedido.itens[0].item.categoria.referencia == 'combustivel')"
                    >
                        {{ compra.valor_total | currency({ fractionCount: 2 }) }}
                    </h2>
                    <h2 class="text-xs-center mb-4" v-else>
                        {{ compra.valor | currency({ fractionCount: 2 }) }}
                    </h2>
                </v-flex>
                <v-flex xs4>
                    <h5>Código:</h5>
                    <h2 class="text-xs-center mb-4">{{ compra.codigo }}</h2>
                </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between fill-height style="font-size: 1.1em">
                <v-flex xs5>
                    <h4 style="font-weight: 500;" class="mb-2 mt-2">
                        Data: <b>{{ compra.data_compra.split("-").reverse().join("/") || voucher && voucher.data_compra.split("-").reverse().join("/") }}</b>
                    </h4>
                </v-flex>
                <v-flex xs5>
                    <h4 style="font-weight: 500;" class="mb-2 mt-2">
                        Hora: <b>{{ compra.horario_compra || voucher && voucher.horario_compra }}</b>
                    </h4>
                </v-flex>
                <v-flex
                    xs5
                    v-if="compra.combustivel || (compra.pedido && compra.pedido.itens[0] && compra.pedido.itens[0].item.categoria.referencia == 'combustivel')"
                >
                    <h4 style="font-weight: 500;" class="mb-2" :class="compra.confirmado ? '' : 'error--text'">
                        Valor {{compra.confirmado ? 'pago' : 'a pagar'}}: <b>{{ compra.valor | currency({ fractionCount: 2 }) }}</b>
                    </h4>
                </v-flex>
                <v-flex xs5>
                    <h4 style="font-weight: 500;" class="mb-2" v-if="compra.taxa_valor > 0 && compra.taxa_tipo_cobranca === 2">
                        Combustível: <b>{{ compra.valor_total | currency({ fractionCount: 2 }) }}</b>
                    </h4>
                    <h4 style="font-weight: 500;" class="mb-2" v-else>
                        Valor total: <b>{{ compra.valor_total | currency({ fractionCount: 2 }) }}</b>
                    </h4>
                </v-flex>
                <v-flex xs5 v-if="compra.taxa_valor > 0">
                    <h4 style="font-weight: 500;" class="mb-2">
                        {{ compra.taxa_tipo_cobranca === 1 ? 'Taxa (Carteira)' : 'Taxa de Serviço' }}: <b>{{ compra.taxa_valor | currency({ fractionCount: 2 }) }}</b>
                    </h4>
                </v-flex>
                <v-flex xs5>
                    <h4 style="font-weight: 500;" class="mb-2" v-if="compra.desconto">
                        {{compra.cashposto ? 'Caskback' : 'Desconto'}}: <b>{{ formatarDesconto(compra.desconto) }}  por {{ compra.combustivel ? `${compra.combustivel.tipo_volume}` : 'und' }}</b>
                    </h4>
                </v-flex>
                <v-flex xs5>
                    <h4 style="font-weight: 500;" class="mb-2">
                        Tipo: <b>{{ compra.tipo_oferta || voucher && voucher.tipo_oferta }}</b>
                    </h4>
                </v-flex>
                <v-flex xs5 v-if="voucher">
                    <h4 style="font-weight: 500;" class="mb-2">
                        Número: <b>{{ voucher.numero || compra.numero }}</b>
                    </h4>
                </v-flex>
                <v-flex xs5 v-if="voucher">
                    <h4 style="font-weight: 500;" class="mb-2">
                        Disponivel: <b>{{ voucher.disponivel ? 'Sim': 'Não' }}</b>
                    </h4>
                </v-flex>
                <v-flex xs5 v-if="!empresa">
                    <h4 style="font-weight: 500;" class="mb-2">
                        Tipo de pagamento: <b>{{ compra.tipo_pagamento }}</b>
                    </h4>
                </v-flex>
                <v-flex xs5>
                    <h4 style="font-weight: 500;" class="mb-2">
                        Local de pagamento: <b>{{ compra.metodo_pagamento === 'pospago' ? 'Estabelecimento' : 'Aplicativo' }}</b>
                    </h4>
                </v-flex>
                <v-flex xs12 v-if="compra.pedido" class="mt-3">
                    <v-list v-if="compra.pedido.itens">
                        <template v-for="(item_pedido, index) in compra.pedido.itens">
                            <v-list-tile :key="index" style="border: solid 0.1em #DCDCDC; height: 4em;">
                                <v-list-tile-avatar>
                                    <v-tooltip bottom>
                                        <svg-filler
                                            slot="activator"
                                            v-if="item_pedido.item.categoria.referencia === 'combustivel'"
                                            :path="item_pedido.item.combustivel.icone ? require(`@/assets/combs/${item_pedido.item.combustivel.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                                            width="30px"
                                            height="30px"
                                            :fill="item_pedido.item.preco ? item_pedido.item.combustivel.color : 'grey'"
                                        />
                                        <v-icon v-else :color="item_pedido.item.categoria.cor" slot="activator">
                                            {{ item_pedido.item.categoria.icone }}
                                        </v-icon>
                                        <span>{{ item_pedido.item.categoria.nome }}</span>
                                    </v-tooltip>
                                </v-list-tile-avatar>
                                <v-list-tile-content style="height: 4em;" class="mt-2">
                                    <v-list-tile-title>
                                        <b>{{ item_pedido.item.nome.toUpperCase() }}</b>
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content style="height: 4em;" class="mt-3">
                                    <v-list-tile-sub-title>
                                        Preço unitário: {{ item_pedido.preco_unitario | currency({ fractionCount: 2 }) }}
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title v-if="!item_pedido.item.combustivel">
                                        Quantidade: {{ item_pedido.quantidade && !item_pedido.item.combustivel ? item_pedido.quantidade : 'Não possui'}}
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title v-if="item_pedido.desconto">
                                        {{compra.cashposto ? 'Caskback' : 'Desconto'}}: {{ formatarDesconto(item_pedido.desconto) }} por {{ item_pedido.item.combustivel ? `${item_pedido.item.combustivel.tipo_volume}` : 'und' }}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-content style="height: 4em;" class="mt-2">
                                    <v-list-tile-sub-title v-if="item_pedido.desconto">
                                        <del>Total: {{ item_pedido.total | currency({ fractionCount: 2 }) }}</del>
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-content style="height: 4em;" class="mt-2">
                                    <v-list-tile-title>
                                        {{ item_pedido.total_com_desconto | currency({ fractionCount: 2 }) }}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-spacer :key="`${index}s`"></v-spacer>
                        </template>
                    </v-list>
                </v-flex>
                <v-flex xs3 class="mb-2 mt-2" v-if="pessoa">
                    <v-layout justify-center>
                        <v-icon size="30">person</v-icon>
                    </v-layout>
                    <h5 style="text-align: center;" v-if="pessoa">{{pessoa.nome_completo}}</h5>
                    <h5 style="text-align: center;" v-if="pessoa">ID: {{pessoa.id_pessoa}}</h5>
                </v-flex>
                <v-flex xs3 class="mb-2 mt-2" v-if="empresa">
                    <v-layout justify-center>
                        <v-icon size="30">mdi-domain</v-icon>
                    </v-layout>
                    <h5 style="text-align: center;">{{ empresa.nome_fantasia}}</h5>
                    <h5 style="text-align: center;">CNPJ: {{ empresa.cnpj}}</h5>
                </v-flex>
                <v-flex xs3 class="mb-2 mt-2" v-if="veiculo">
                    <v-layout justify-center>
                        <v-icon size="30">directions_car</v-icon>
                    </v-layout>
                    <h5 style="text-align: center;" v-if="veiculo.modelo && veiculo.marca">{{veiculo.modelo}} - {{veiculo.marca}}</h5>
                    <h5 style="text-align: center;">Placa: {{veiculo.identificacao}}</h5>
                </v-flex>
                <v-flex xs11 v-if="empresa" class="mt-3">
                    <v-text-field
                        label="Digite o odômetro do veículo"
                        outline
                        v-model="hodometro"
                    />
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-alert
            :value="true"
            type="error"
            style="font-size: 1.2em"
            class="pa-2"
            v-if="!compra.confirmado"
        >
                Essa compra deve ser paga no estabelecimento
        </v-alert>
        <v-divider></v-divider>
        <v-card-text>
            <v-layout justify-space-around wrap class="mb-2">
                <v-flex xs9>
                    <h6
                        class="mb-2 text-xs-center"
                        style="
                            font-size: 1.1em;
                            margin-left: 9em;
                        "
                    >
                        Digite o PIN do frentista responsável
                    </h6>
                </v-flex>
                <v-flex xs3>
                    <v-btn
                        round
                        color="primary"
                        small
                        @click="selecionarFrentista = true"
                    >
                        Alterar frentista
                    </v-btn>
                </v-flex>
                <v-flex xs2>
                    <v-icon size="40">engineering</v-icon>
                </v-flex>
                <v-flex xs10>
                    <h4>Lido por: {{frentistaSelecionado.nome}}</h4>
                    <h4>Matricula: {{frentistaSelecionado.matricula}}</h4>
                </v-flex>
            </v-layout>
            <Pin v-if="!autenticado" :frentista="frentistaSelecionado" @autenticado="autenticado = true"/>
            <h3 v-else class="success--text text-xs-center mt-3 mb-3">A leitura já pode ser realizada</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn
                block
                large
                color="primary"
                :disabled="!autenticado"
                flat
                :loading="loading"
                @click="usarVoucher"
            >
                Realizar Leitura
            </v-btn>
        </v-card-actions>
        <v-dialog
            v-if="selecionarFrentista"
            v-model="selecionarFrentista"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <selecionar-frentista
                @fechar="selecionarFrentista = false, autenticado = false"
            />
        </v-dialog>
    </v-card>
</template>

<script>

import Pin from '@/components/Pin'
import SelecionarFrentista from '@/components/dialogs/DialogSelecionarFrentista'

export default {
  components: { Pin, SelecionarFrentista },
  data: () => ({
    autenticado: false,
    veiculo: undefined,
    hodometro: undefined,
    selecionarFrentista: false,
    pessoa: undefined,
    empresa: undefined,
    tipos: {
      'P': 'Produto Físico',
      'D': 'Produto Digital',
      'S': 'Serviço'
    }
  }),
  props: ['compra', 'voucher', 'tipo'],
  computed: {
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    loading () {
      return this.$store.getters.loading
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  beforeMount () {
    this.veiculo = (this.compra && this.compra.veiculo && !this.isNumero(this.compra.veiculo) ? this.compra.veiculo : undefined) || (this.voucher && this.voucher.veiculo && !this.isNumero(this.voucher.veiculo) ? this.voucher.veiculo : undefined)
    this.empresa = this.voucher && this.voucher.empresa ? this.voucher.empresa : this.compra && this.compra.empresa ? this.compra.empresa : undefined
    if (this.empresa) {
      this.pessoa = this.voucher && this.voucher.funcionario ? this.voucher.funcionario.pessoa : this.compra && this.compra.funcionario ? this.compra.funcionario.pessoa : undefined
    } else {
      this.pessoa = this.voucher && this.voucher.usuario_beneficiado ? this.voucher.usuario_beneficiado.pessoa : this.compra && this.compra.cliente ? this.compra.cliente.pessoa : undefined
    }
  },
  methods: {
    isNumero (valor) {
      return typeof valor === 'number' && !isNaN(valor)
    },
    formatarDesconto (desconto) {
      if (!desconto) return '0%'
      else if (desconto % 1 !== 0) {
        return `R$ ${desconto.toFixed(2).replace('.', ',')}`
      }
      return `${desconto}%`
    },
    usarVoucher () {
      const data = {
        hodometro: this.hodometro ? this.hodometro : null,
        id_frentista: this.frentistaSelecionado.id_frentista
      }

      if (this.voucher && this.voucher.id_voucher) {
        data.id_voucher = this.voucher.id_voucher
      } else if (this.compra) {
        data.id_compra = this.compra.id_compra
      } else {
        this.$store.dispatch('setError', 'Voucher Inválido. Entre em contato com Apetrus')
        return
      }

      if (this.tipo === 'placa') data.placa = this.veiculo.identificacao
      else data.cpf = this.pessoa.cpf

      this.$store.dispatch('realizarleituraVoucher', data).then(() => {
        this.$emit('concluido')
        this.$emit('fechar')
      })
    }
  }

}
</script>
